import {
  KebabHorizontalIcon,
  PencilIcon,
  PlusIcon,
  TrashIcon,
} from "@primer/octicons-react";
import {
  ActionList,
  ActionMenu,
  Box,
  IconButton,
  useConfirm,
} from "@primer/react";
import { useEffect, useState } from "react";
import { useCommonContext } from "../../../contexts/common";
import { NotifyHelper } from "../../../helpers/toast";
import DataTable from "../../../components/ui/data-table";
import TextTranslated from "../../../components/text";
import Button from "../../../components/ui/button";
import PhongDetailModal from "./TrangThaiDetailModal";
import { ts_hocsinh_noitru_status } from "../../../models/response/noi-tru/ts_hocsinh_noitru_status";
import { hocSinhNoiTruStatusApi } from "../../../api/hocSinhNoiTruApi";
import TrangThaiDetailModal from "./TrangThaiDetailModal";
const TrangThaiNoiTru = () => {
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailModalDangKy, setIsShowDetailModalDangKy] = useState(false);

  const [selectedId, setSelectedId] = useState(0);
  const [TrangThais, setTrangThais] = useState<ts_hocsinh_noitru_status[]>([]);
  const { translate } = useCommonContext();
  const [isSaving, setIsSaving] = useState(false);
  const confirm = useConfirm();

  useEffect(() => {
    handleReloadAsync();
  }, []);
  const handleReloadAsync = async () => {
    const res = await hocSinhNoiTruStatusApi.selectAll();
    if (res.is_success) {
      setTrangThais(res.data);
    } else {
      NotifyHelper.Error("Có lỗi");
    }
  };

  const handeDelete = async (id: number) => {
    if (
      await confirm({
        content: "Bạn có chắc chắn muốn xóa trạng thái này?",
        title: "Lưu ý",
        cancelButtonContent: "Không xóa",
        confirmButtonContent: "Xóa trạng thái",
        confirmButtonType: "danger",
      })
    ) {
      const res = await hocSinhNoiTruStatusApi.delete(id);
      if (res.is_success) {
        NotifyHelper.Success("Success");
        handleReloadAsync();
      } else {
        NotifyHelper.Error("Có lỗi");
      }
    }
  };
  return (
    <Box sx={{ p: 3 }}>
      <DataTable
        height={`${window.innerHeight - 250}px`}
        columns={[
          {
            id: "cmd",
            width: "50px",
            caption: "",
            align: "center",
            cellRender: (data: ts_hocsinh_noitru_status) => {
              return (
                <ActionMenu>
                  <ActionMenu.Anchor>
                    <IconButton
                      icon={KebabHorizontalIcon}
                      variant="invisible"
                      aria-label="Open column options"
                    />
                  </ActionMenu.Anchor>

                  <ActionMenu.Overlay>
                    <ActionList>
                      <ActionList.Item
                        onSelect={() => {
                          setIsShowModal(true);
                          if (data.id !== undefined) {
                            setSelectedId(data.id);
                          }
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <PencilIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Edit" />
                      </ActionList.Item>
                      <ActionList.Divider />
                      <ActionList.Item
                        variant="danger"
                        onSelect={() => {
                          if (data.id !== undefined) {
                            handeDelete(data.id);
                          }
                        }}
                      >
                        <ActionList.LeadingVisual>
                          <TrashIcon />
                        </ActionList.LeadingVisual>
                        <TextTranslated value="Base.Label.Delete" />
                      </ActionList.Item>
                    </ActionList>
                  </ActionMenu.Overlay>
                </ActionMenu>
              );
            },
          },
          {
            isMainColumn: true,
            dataField: "trang_thai",
            width: "auto",
            caption: `Trạng thái`,
            cellRender: (data: ts_hocsinh_noitru_status) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    whiteSpace: "nowrap",
                  }}
                >
                  {data.trang_thai}
                </Box>
              );
            },
          },
        ]}
        data={TrangThais}
        title="Trạng thái"
        subTitle={`${translate("Base.Label.TotalCount")}: ${TrangThais.length}`}
        searchEnable
        actionComponent={
          <>
            <Button
              text={translate("Base.Label.Create")}
              leadingVisual={PlusIcon}
              variant="primary"
              size="medium"
              onClick={() => {
                setIsShowModal(true);
                setSelectedId(0);
              }}
            />
          </>
        }
      />
      {isShowModal && (
        <TrangThaiDetailModal
          id={selectedId}
          onClose={() => {
            setIsShowModal(false);
          }}
          onSuccess={() => {
            handleReloadAsync();
            setIsShowModal(false);
          }}
        />
      )}
    </Box>
  );
};

export default TrangThaiNoiTru;
